<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="楼层总数" prop="levelNum">
                        <input-number v-model="info.levelNum" placeholder :allowDecimal="false" :disabled="loading"></input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="单元数" prop="unitNum">
                        <input-number v-model="info.unitNum" placeholder :allowDecimal="false" :disabled="loading"></input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="每单元户数" prop="unitHouseNum">
                        <input-number v-model="info.unitHouseNum" placeholder :allowDecimal="false" :disabled="loading"></input-number>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <p class="source-msg">说明: 系统将根据楼层总数、单元数及单元每层户数自动生成房号，快速创建房源</p>
    </div>
</template>
<script>
import { genResources, floorView } from '@/api/proj-manager'
import Dict from '@/utils/dict'
export default {
    name: 'FormFloorForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                floorId: this.id,
                projId: '',
                levelNum: '', //楼层总数
                unitNum: '', //单元数
                unitHouseNum: '', //每单元户数
                ver: '' //版本号
            },
            loading: false
        }
    },

    computed: {
        ruleValidate() {
            return {
                levelNum: [{ required: true, message: '楼层总数必填' }],
                unitNum: [{ required: true, message: '单元数必填' }],
                unitHouseNum: [{ required: true, message: '每单元户数必填' }]
            }
        }
    },

    methods: {
        fetch() {
            return floorView(this.id)
        },
        setData(data) {
            this.info.levelNum = data.levelNum
            this.info.unitNum = data.unitNum
            this.info.unitHouseNum = data.unitHouseNum
        }
    },

    mounted() {
        var $info = this.$refs.info
        this.info.projId = this.$route.params.id
        this.loading = true
        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([this.fetch()])
                .then(args => {
                    let [floor] = args
                    this.setData(floor.data)
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.loading = true
                    var formData = Object.assign({}, this.info)
                    return genResources(formData)
                })
                .then(res => {
                    this.$Message.success(this.$t('tips.add.success'))
                })
                .catch(err => (options.closeModal = false))
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
.source-msg {
    font-size: 14px;
    line-height: 20px;
    color: red;
    padding-left: 28px;
}
</style>
